import { ChunkStage, World, WorldName } from './world';
import { ParallaxDirection, ParallaxType } from '../../core/modules/Parallax/ParallaxController';
import { RelicName } from '../relics/relic';

import CaveStartChunk from '../chunks/cave/CaveStartChunk';
import CaveChunk1 from '../chunks/cave/CaveChunk1';
import CaveChunk2 from '../chunks/cave/CaveChunk2';
import CaveChunk3 from '../chunks/cave/CaveChunk3';
import CaveChunk4 from '../chunks/cave/CaveChunk4';
import CaveChunkRelic1 from './../chunks/cave/CaveChunkRelic1';
import CaveChunkHard1 from './../chunks/cave/CaveChunkHard1';
import CaveChunkHard2 from './../chunks/cave/CaveChunkHard2';
import CaveChunkHard3 from '../chunks/cave/CaveChunkHard3';
import CaveEndChunk from './../chunks/cave/CaveEndChunk';

export const caveWorld: World = {
  id: WorldName.Cave,
  texture: 'game-all',
  parallaxLayers: [
    // {
    //   type: ParallaxType.Tile,
    //   texture: 'game-all',
    //   frame: 'bg-cave.jpg',
    //   depth: 1,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -300,
      y: 384,
      texture: 'game-all',
      images: [
        {
          frame: 'bg-cave.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-cave.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-cave.jpg',
          gapBefore: -2
        }
      ],
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 290,
    //   width: 1920,
    //   height: 97,
    //   texture: 'game-all',
    //   frame: 'tile-lava.png',
    //   depth: 4,
    //   scrollX: 0,
    //   scrollY: 1,
    //   speedX: 0.75,
    //   speedY: 0,
    //   naturalDriftX: 1,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -670,
      y: 290,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-lava.png',
          gapBefore: -1
        },
        {
          frame: 'tile-lava.png',
          gapBefore: -1
        },
        {
          frame: 'tile-lava.png',
          gapBefore: -1
        }
      ],
      depth: 4,
      scrollX: 0,
      scrollY: 1,
      speedX: 0.75,
      speedY: 0,
      naturalDriftX: 1,
      naturalDriftY: 0
    }
  ],
  playerSpawnPoint: { x: 100, y: -20 },
  hasHardFloor: true,
  deathFloorY: 300,
  chunkStartX: 0,
  chunkStartY: 300,
  relics: [
    {
      relic: RelicName.PlatinumMagnet,
      distance: 10000,
      chunks: [CaveChunkRelic1]
    }
  ],
  chunks: {
    [ChunkStage.Start]: [CaveStartChunk],
    // [ChunkStage.Mid]: [CaveChunk1, CaveChunk2, CaveChunk3, CaveChunk4],
    // [ChunkStage.Mid]: [CaveChunkRelic1],
    [ChunkStage.Easy]: [CaveChunk1, CaveChunk2, CaveChunk3, CaveChunk4],
    //[ChunkStage.Easy]: [CaveChunkHard1, CaveChunkHard2, CaveChunkHard3],
    // [ChunkStage.Easy]: [CaveChunkRelic1],
    [ChunkStage.Hard]: [CaveChunk1, CaveChunk2, CaveChunk3, CaveChunk4, CaveChunkHard1, CaveChunkHard2, CaveChunkHard3],
    // [ChunkStage.Hard]: [CaveChunkHard1, CaveChunkHard2]
    [ChunkStage.End]: [CaveEndChunk]
  },
  stageOrdering: [
    {
      name: ChunkStage.Start,
      count: 1
    },
    {
      name: ChunkStage.Easy,
      distance: 37500,
      // count: 1,
      rushMax: 0
    },
    {
      name: ChunkStage.Hard,
      distance: 37500,
      // count: 1,
      rushMin: 1
    },
    {
      name: ChunkStage.End,
      count: 1
    }
  ]
};
